var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Platform-Admin",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Platform-Admin-/-Question-Bank-New",
    transform: "translate(-380.000000, -177.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stats",
    transform: "translate(96.000000, 152.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RN",
    transform: "translate(260.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(24.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Base",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "user-nurse",
    transform: "translate(12.000000, 10.000000)",
    fill: "#DBAC31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.11125,16.8750835 L12,21.905374 L6.88875,16.8750835 C3.05892857,17.0385587 0,20.1234942 0,23.9303573 C0,25.6256742 1.39615204,27 3.11839286,27 L20.8816071,27 C22.603848,27 24,25.6256742 24,23.9303573 C24,20.1234942 20.9410714,17.0385587 17.11125,16.8750835 Z M12,16.0313404 C15.7870954,16.0313404 18.8571441,13.0092874 18.8571441,9.28139604 L18.8571441,3.47117049 C18.8580141,2.76708244 18.4146949,2.13646287 17.745,1.88915228 L13.20375,0.214849678 C12.4276332,-0.0716165594 11.5723668,-0.0716165594 10.79625,0.214849678 L6.255,1.89126164 C5.58603983,2.13830151 5.14285714,2.76785414 5.14285714,3.47117049 L5.14285714,9.28139604 C5.14285714,13.0092874 8.21290457,16.0313404 12,16.0313404 Z M9.85714286,3.77966405 C9.85714286,3.63404329 9.97706658,3.51599434 10.125,3.51599434 L11.2858929,3.51599434 L11.2858929,2.37324986 C11.2858929,2.2276291 11.4058166,2.10958015 11.55375,2.10958015 L12.44625,2.10958015 C12.5941834,2.10958015 12.7141071,2.2276291 12.7141071,2.37324986 L12.7141071,3.51599434 L13.875,3.51599434 C14.0229334,3.51599434 14.1428571,3.63404329 14.1428571,3.77966405 L14.1428571,4.65821149 C14.1428571,4.80383225 14.0229334,4.92188119 13.875,4.92188119 L12.7141071,4.92188119 L12.7141071,6.06462568 C12.7141071,6.21024644 12.5941834,6.32829538 12.44625,6.32829538 L11.55375,6.32829538 C11.4058166,6.32829538 11.2858929,6.21024644 11.2858929,6.06462568 L11.2858929,4.92188119 L10.125,4.92188119 C9.97706658,4.92188119 9.85714286,4.80383225 9.85714286,4.65821149 L9.85714286,3.77966405 Z M7.71428571,8.437653 L16.2857143,8.437653 L16.2857143,9.28139604 C16.2857143,11.6113281 14.3669346,13.5001113 12,13.5001113 C9.63306536,13.5001113 7.71428571,11.6113281 7.71428571,9.28139604 L7.71428571,8.437653 Z",
    id: "Shape"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRn);
export default __webpack_public_path__ + "static/media/icon-RN.182e6598.svg";
export { ForwardRef as ReactComponent };